<template>
  <v-dialog
    v-model="visibility"
    max-width="600"
    persistent
  >
    <v-card>
      <v-alert
        v-model="error"
        dismissible
        type="error"
      >
        {{errorMsg}}

      </v-alert>
      <div class="px-0">
        <v-card-title class="headline pl-4 py-2 pr-2">
          Zarządzaj tagami
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div v-if="tags">
          <div class="pt-4">
            <div class="px-4">
              <div class="body-2 grey--text">
                Wybierz tagi którymi chcesz oznaczyć ten plik
              </div>
            </div>

            <div class="px-4">
              <v-autocomplete
                v-model="selectedTags"
                :items="tags"
                item-text="name"
                item-value="id"
                multiple
                label="Wybierz tag"
              >
              </v-autocomplete>
            </div>
            <div v-if="tags && tagsList.length > 0">
              <div class="px-4">
                <v-chip
                  text-color="white"
                  class="ml-0 mr-3"
                  v-for="(tag) in tagsList"
                  :key="tag.id"
                  :style="{backgroundColor: tag.color_hex}"
                  close
                  @input="removeTag(tag.id)"
                >{{tag.name}}</v-chip>
              </div>
            </div>

          </div>
          <v-card-actions class="px-4 py-4">
            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="tagFile"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';

export default {
  name: 'tags-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    dialogBusy: false,
    selectedTags: [],
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
      'tags',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'tag';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    tagsList() {
      const list = [];
      this.selectedTags.forEach((id) => {
        const currentTag = this.tags.find(tag => tag.id === parseInt(id, 0));
        if (currentTag) {
          list.push(currentTag);
        }
      });
      return list;
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'saveTags',
    ]),
    cleardData() {
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.dialogBusy = false;
      this.selectedTags = [];
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    removeTag(id) {
      const index = this.selectedTags.indexOf(id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      }
    },
    async tagFile() {
      this.busy = true;
      try {
        await this.saveTags({ tags_id: this.selectedTags });
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
    getCurrentTags() {
      const currentTags = this.dialogVisibility.tags;
      if (currentTags && currentTags.length > 0) {
        currentTags.forEach((tag) => {
          this.selectedTags.push(parseInt(tag.id, 0));
        });
      }
    },
  },
  watch: {
    visibility(val) {
      if (val === true) {
        this.cleardData();
        this.getCurrentTags();
      }
    },
  },
};
</script>
